import type { TOC } from '@ember/component/template-only';

interface UiCardSignature {
  Args: {
    border?: boolean;
    dark?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="ui__card {{if @border 'ui__card--border'}} {{if @dark 'ui__card--dark'}}" ...attributes>
    {{yield}}
  </div>
</template> satisfies TOC<UiCardSignature>;
